// src/modules/app-views/services/pages/Ai/modals/SettingsModal/Step1.jsx
// *******************************************************************************
// IMPORTS
// *******************************************************************************
import { Alert, Card, Flex, Tooltip } from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import SimpleTextArea from 'components/SimpleComponents/SimpleTextArea';
import translateX from 'utils/translateX';

// *******************************************************************************
// STEP CONTENT COMPONENT
// *******************************************************************************
const SettingsModalStepContent = () => {
  // ---------------------------------------------------------------------------
  // 9. UI
  // ---------------------------------------------------------------------------
  return (
    <>
      {/* Business Context Card */}
      <Card
        size="small"
        title={
          <Flex align="center" gap={8}>
            {translateX('ai_business_context_title')}
            <Tooltip title={translateX('ai_business_context_tooltip')}>
              <QuestionCircleOutlined style={{ color: 'rgba(0,0,0,0.45)', }} />
            </Tooltip>
          </Flex>
        }
        style={{ marginBottom: 16 }}
      >
        <SimpleTextArea
          name="aiBusinessContext"
          noLabel={true}
          placeholder={translateX('ai_business_context_placeholder')}
          rows={6}
          disabled
        />
      </Card>

      {/* Assistant Profile Card */}
      <Card
        size="small"
        title={
          <Flex align="center" gap={8}>
            {translateX('ai_assistant_profile_title')}
            <Tooltip title={translateX('ai_assistant_profile_tooltip')}>
              <QuestionCircleOutlined style={{ color: 'rgba(0,0,0,0.45)'}} />
            </Tooltip>
          </Flex>
        }
        style={{ marginBottom: 16 }}
      >
        <SimpleTextArea
          name="aiAssistantProfile"
          noLabel={true}
          placeholder={translateX('ai_assistant_profile_placeholder')}
          disabled={false}
          rows={6}
        />
      </Card>

      {/* Info Alert */}
      <Alert
        type="info"
        title={translateX('ai_settings_impact_note')}
      />
    </>
  );
};

// *******************************************************************************
// STEP CONFIGURATION
// *******************************************************************************
function settingsModalStep() {
  return {
    stepTitle: 'ai_settings',
    stepTooltip: 'ai_settings',
    content: () => <SettingsModalStepContent />,
    validationFields: [],
  };
}

// *******************************************************************************
// EXPORT
// *******************************************************************************
export default settingsModalStep;
